import { MyRequestsTable } from './MyRequestsTable';

export const MyRequests = () => <MyRequestsTable />;
